/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { TravelOptionViewModel } from '../models/TravelOptionViewModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class TravelOptionService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns TravelOptionViewModel
     * @throws ApiError
     */
    public travelOptionGet(): Observable<Array<TravelOptionViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/traveloptions',
        });
    }
}
